<template>
    <div>
        <div class="shipping-status-counters">
            <CounterCard v-for="(counter, index) in counters" :key="index" :icon="counter.icon" :title="counter.title"
                :value="counter.value" :percentage="counter.percentage" :color="counter.color" />
        </div>
    </div>
</template>

<script>
import CounterCard from './CounterCard.vue';
import { mapGetters } from 'vuex';
export default {
    name: 'ShippingStatusCounters',
    components: {
        CounterCard
    },
    computed: {
        ...mapGetters(['dashboardStateCounters']),
        counters() {
            console.log(this.dashboardStateCounters)
            return [
                {
                    icon: 'pending_actions',
                    title: 'Total Envíos',
                    color: '#50A5F1',
                    value: this.dashboardStateCounters?.total || 0,
                    percentage: this.dashboardStateCounters?.totalPercentage || 0
                },
                {
                    icon: 'local_shipping',
                    title: 'Entregados',
                    color: '#34C38F',
                    value: this.dashboardStateCounters?.delivered || 0,
                    percentage: this.dashboardStateCounters?.deliveredPercentage || 0
                },
                {
                    icon: 'check_circle',
                    title: 'Por Entregar',
                    color: '#50A5F1',
                    value: this.dashboardStateCounters?.inProgress || 0,
                    percentage: this.dashboardStateCounters?.inProgressPercentage || 0
                },
                {
                    icon: 'hourglass_empty',
                    title: 'Pendientes',
                    color: '#F1B44C',
                    value: this.dashboardStateCounters?.pending || 0,
                    percentage: this.dashboardStateCounters?.pendingPercentage || 0
                },
                {
                    icon: 'cancel',
                    title: 'Rechazados',
                    color: '#F46A6A',
                    value: this.dashboardStateCounters?.rejected || 0,
                    percentage: this.dashboardStateCounters?.rejectedPercentage || 0
                }
            ]
        }
    }
}
</script>

<style scoped>
.shipping-status-counters {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
    gap: 1rem;
}
</style>